import axios from "axios"
import { useEffect, useState } from "react"
import { Fade } from "react-awesome-reveal"
import PageLoader from "../../components/global/loader/PageLoader"
import { ContactSection } from "../../components/home/ContactSection"
import './styles.scss';

export const ContactUs = () => {
    const [isFetchingPageData, setIsFetchingPageData] = useState(true);
    const [pageContent, setPageContent] = useState(null);
    const [globalOptions, setGlobalOptions] = useState(null);

    useEffect(() => {
        fetchPageContent();
        fetchGlobalOptions();
    }, []);

    const fetchGlobalOptions = async () => {
      try {
        const { data } = await axios.get("/wp-admin/admin-ajax.php?action=get_global_site_options");
        setGlobalOptions(data?.data ?? null);
      } catch (e) {
        setGlobalOptions(null);
      }
    }

    const formatPhoneNumber = ( phoneNumber ) => {
        var phonePattern = /^\+\d(\d{3})(\d{3})(\d{4})$/;
        var matches = phoneNumber?.match(phonePattern);
        if (matches) {
            return '(' + matches[1] + ') ' + matches[2] + '-' + matches[3];
        } else {
            return phoneNumber;
        }
    }


    const fetchPageContent = async () => {
        setIsFetchingPageData(true);
        try {
            const { data } = await axios.get(`/wp-admin/admin-ajax.php?action=get_pages_by_page_name&page_name=contact_us`);
            setPageContent(data);
            if (data?.yoast_title?.length > 0) {
                const finalTitle = data.yoast_title
                    .replace("%%title%%", data?.page?.post_title ? data?.page?.post_title : '')
                    .replace("%%page%%", "")
                    .replace("%%sep%%", "-")
                    .replace("%%sitename%%", "Alinea Law PLLC")

                document.title = finalTitle;
            } else {
                document.title = data?.page?.post_title ? `${data?.page?.post_title} - Alinea Law PLLC` : "Contact - Alinea Law PLLC";
            }
            if (document.querySelector('#wp-admin-bar-edit a')) {
                document.querySelector('#wp-admin-bar-edit a').innerText = `Edit Page`;
                document.querySelector('#wp-admin-bar-edit a').href = `/wp-admin/post.php?post=${data?.page?.ID}&action=edit`;
            }
        } catch (err) {
            console.log(err);
        } finally {
            setIsFetchingPageData(false);
        }
    }

    return <Fade delay={1}>
        <main id="main" className="internal-page contact-us">
            {
                !isFetchingPageData && <>                
                    <ContactSection />
                </>
            }

            {
                isFetchingPageData && <PageLoader />
            }
        </main>
    </Fade>
}